 /* eslint-disable no-nested-ternary */
import React from 'react'; // eslint-disable-line no-unused-vars
import styled from 'styled-components';

const Button = styled.button`
  font: ${props => (props.invert ? '12px' : '16px')} dinpro-bold;
  ${props =>
    props.invert &&
    `border: 1px solid ${props.theme.colors.filter};`} cursor: pointer;
  letter-spacing: -0.02em;
  color: ${props =>
    (props.white
      ? props.theme.colors.mainText
      : props.invert ? props.theme.colors.filter : 'white')};
  border-radius: ${props =>
    (props.white ? '5px' : props.invert ? '17px' : '22px')};
  ${props => props.fullWidth && 'width: 100%'};
  ${props => !props.noshadow && 'box-shadow: 0 10px 40px rgba(69, 69, 69, 0.1);'};
  ${props =>
    !props.white &&
    !props.invert &&
    'background-image: linear-gradient(to right, #0099ff 0%, #0066ff 100%);'} ${props =>
      (props.white
        ? 'background: white;'
        : props.invert ? 'background: transparent;' : '')} padding: 10px 40px;
  ${props => props.p && `padding: ${props.p};`} ${props =>
      props.m && `margin: ${props.m};`} transition: 0.3s;
  transition: 0.3s ease-in-out;
  &:hover {
    ${props => (props.invert ? 'color: white' : '')};
    ${props =>
      (props.invert ? `background: ${props.theme.colors.filter}` : '')};
    ${props =>
      !props.invert &&
      !props.white &&
      'box-shadow: 0 14px 56px -20px rgba(0,0,0,.64);'} ${props =>
        !props.invert &&
        !props.white &&
        'background-image: linear-gradient(to right, #0099ff 0%, #001ecc 100%);'};
  }
`;

export default Button;
